import React from 'react';
import withIcon from '../utilities/withIcon';

const IconTableRow = () => {
  return (
    <g>
      <path d="M14.3061 15.9959H1.6983A1.6959 1.6959 0 0 1 .0041 14.302V1.7785A1.63 1.63 0 0 1 .4312.5722 1.7188 1.7188 0 0 1 1.6983 0h12.6078A1.6958 1.6958 0 0 1 16 1.6939V14.302a1.6958 1.6958 0 0 1-1.6939 1.6939zM1.6983 1.3885a.3369.3369 0 0 0-.2373.1156.2475.2475 0 0 0-.0719.1763l.0035.0688V14.302a.3022.3022 0 0 0 .3057.3054h12.6078a.302.302 0 0 0 .3054-.3054V1.6939a.302.302 0 0 0-.3054-.3054z" />
      <path d="M.6707 3.7214h14.6627v1.3885H.6707z" />
      <path d="M.79621001 4.24571892L3.31230328.2367901l1.17622688.73822626L1.9724369 4.98394518zM4.35097781 4.24562379L6.86701792.23677967 8.0432448.97500593 5.5272047 4.98385005zM7.9056546 4.2456449L10.42180101.23663138 11.5981126.9749108 9.08196617 4.98392432zM11.46010098 4.24587677l2.51578674-4.0093573 1.1764723.73821144-2.51578674 4.0093573z" />
    </g>
  );
};

export default withIcon(IconTableRow);
